import { Expose, plainToInstance } from "class-transformer";
import camelcaseKeys from "camelcase-keys";

export class ReceiveSummeryReportModel {
  @Expose()
  public date?: string;

  // @Expose()
  // public dateFa?: string;

  @Expose()
  public amount?: number;

  @Expose()
  public bankName?: string;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(ReceiveSummeryReportModel, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(ReceiveSummeryReportModel, camelcaseKeys(data, { deep: true }) as ReceiveSummeryReportModel[], { excludeExtraneousValues: true });
  }
}
